var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 20.5714C2.375 21.3616 2.98945 22 3.75 22H20.25C21.0105 22 21.625 21.3616 21.625 20.5714V7.71429H2.375V20.5714ZM9.25 11.1071C9.25 10.8125 9.48203 10.5714 9.76562 10.5714H14.2344C14.518 10.5714 14.75 10.8125 14.75 11.1071V11.4643C14.75 11.7589 14.518 12 14.2344 12H9.76562C9.48203 12 9.25 11.7589 9.25 11.4643V11.1071ZM21.625 2H2.375C1.61445 2 1 2.63839 1 3.42857V5.57143C1 5.96429 1.30937 6.28571 1.6875 6.28571H22.3125C22.6906 6.28571 23 5.96429 23 5.57143V3.42857C23 2.63839 22.3855 2 21.625 2Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.1eeb64b8118273669e7a1704bf7be7b5.svg";
export { ForwardRef as ReactComponent };